import buildQuery from "./buildQuery";

/**
 * Build valid url from provided parameters
 * 
 * @param {string} protocol - url protocol, ex. https://
 * @param {string} host - url host, ex. loomissc.dev.local
 * @param {string} apiSuffix - api suffix, ex. /api/loomis/news
 * @param {Array} additionalParams - additional parameters to join at the end after /
 * @param {Object} queryParams - query params, ex. ?page=1&perPage=3
 * @returns {string} valid url
 */
export default (
  protocol,
  host,
  apiSuffix,
  additionalParams = [],
  queryParams = {}
) => {
  const baseUrl = `${host}/${apiSuffix}/${
    additionalParams ? additionalParams.join("/") : ""
  }`.replace(/\/\//g, "/");
  const query = buildQuery(queryParams);

  return `${protocol}${baseUrl}${query}`;
};
